import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../../../App/AppContext';
import { Grid, InputLabel, Button, TextField, FormControlLabel, Checkbox, Paper, Popper, ClickAwayListener, FormHelperText } from '@material-ui/core';
import { TextBox, DateTimePicker, SecondaryButton, SelectBox, SingelSelect } from '../../FormInput';
import { getVehicleDetailsByReg, getJobBookingDropdowns, createHeaderRecord } from '../../Service/create-job-service';
import VehicleModal from './VehicleModal';

const CreateJobs = (props) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        HighPriority: false,
        WIPNumber: '',
        CustomerName: '',
        Registration: '',
        S24ChassisNumber: '',
        DateTimeDueIn: '',
        DateTimeDueOut: '',
        MakeModel: '',
        AccountNo: '',
        CreatingOperator: '',
        ServiceText001: '',
        WorkflowAssignedDate: '',
        OwningOperator: '',
        PriorityNumber: '',
        CustomerRatingNotes: '',
        BranchId: '',
        DeleteFlag: false,
        CustomerWaiting: false,
        CourtesyCarReq: false,
        IsFMOrWarranty: false,
        IsBreakdown: false,
        IsNightShift: false,
        WLDateIn: '',
        WLDateOut: '',
        FranchiseCode: ''
    });

    const [dropdowns, setDropdowns] = useState({});
    const [regOptions, setRegOptions] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showRegPopper, setShowRegPopper] = useState(false);
    const [showVehicleModal, setShowVehicleModal] = useState(false);
    const [searchedReg, setSearchedReg] = useState('');
    const [errors, setErrors] = useState({});
    const [isBtnLoader, setIsBtnLoader] = useState(false);

    useEffect(() => {
        const fetchDropdowns = async () => {
            try {
                let res = await getJobBookingDropdowns();
                if (res.success && res.data) {
                    setDropdowns(res.data);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchDropdowns();
    }, []);

    const handleSearchReg = async (value) => {
        if (value && value.length > 2) {
            try {
                let res = await getVehicleDetailsByReg(value);
                if (res.success && res.data) {
                    const list = Array.isArray(res.data) ? res.data : [];
                    setRegOptions(list);
                } else {
                    setRegOptions([]);
                }
                setShowRegPopper(true);
            } catch (err) {
                console.error(err);
                setRegOptions([]);
                setShowRegPopper(true);
            }
        } else {
            setRegOptions([]);
            setShowRegPopper(false);
        }
    };

    const handleRegChange = (event) => {
        const { value } = event.target;
        setState((st) => ({ ...st, Registration: value }));
        setSearchedReg(value);
        setAnchorEl(event.currentTarget);
        handleSearchReg(value);
        if (errors.Registration) {
            setErrors((errs) => ({ ...errs, Registration: null }));
        }
    };

    const handleCloseVehicleModal = (isSaved, newVehicleData) => {
        setShowVehicleModal(false);
        if (isSaved && newVehicleData) {
            const regValue = newVehicleData.RegistrationNumber || '';
            setState((st) => ({
                ...st,
                Registration: regValue,
                S24ChassisNumber: newVehicleData.ChassisNumber || '',
                MakeModel: newVehicleData.ModelCode || '',
                AccountNo: newVehicleData.AccountCode || '',
                FranchiseCode: newVehicleData.Franchise || ''
            }));
            setErrors((errs) => ({
                ...errs,
                Registration: null,
                S24ChassisNumber: null,
                MakeModel: null,
                AccountNo: null,
                FranchiseCode: null
            }));
            if (regValue) {
                handleSearchReg(regValue);
                setSearchedReg(regValue);
            }
        }
    };

    const handleSelectReg = (newValue) => {
        if (typeof newValue === 'object' && newValue !== null) {
            const regValue = newValue.registrationNumber || newValue.Registration || newValue.reg || newValue.Reg || '';
            setState((st) => ({
                ...st,
                Registration: regValue,
                MakeModel: newValue.modelCode || '',
                S24ChassisNumber: newValue.chassisNumber || '',
                AccountNo: newValue.accountCode || '',
                FranchiseCode: newValue.franchise || '',
                ServiceText001: newValue.serviceText001 || ''
            }));
            setErrors((errs) => ({
                ...errs,
                Registration: regValue ? null : errs.Registration,
                MakeModel: newValue.modelCode ? null : errs.MakeModel,
                S24ChassisNumber: newValue.chassisNumber ? null : errs.S24ChassisNumber,
                AccountNo: newValue.accountCode ? null : errs.AccountNo,
                FranchiseCode: newValue.franchise ? null : errs.FranchiseCode,
                ServiceText001: newValue.serviceText001 ? null : errs.ServiceText001
            }));
        }
        setShowRegPopper(false);
    };

    const fieldChange = (event) => {
        const { name, value, type, checked } = event.target;
        setState((st) => ({
            ...st,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (errors[name]) {
            setErrors((errs) => ({ ...errs, [name]: null }));
        }
    };

    const handleSave = async () => {
        let newErrors = {};
        const requiredFields = [
            'WIPNumber',
            'CustomerName',
            'Registration',
            'S24ChassisNumber',
            'MakeModel',
            'AccountNo',
            'CreatingOperator',
            'ServiceText001',
            'OwningOperator',
            'CustomerRatingNotes'
            // 'FranchiseCode',
            // 'BranchId'
        ];

        requiredFields.forEach((field) => {
            if (state[field] === undefined || state[field] === null || String(state[field]).trim() === '') {
                newErrors[field] = 'Required';
            }
        });

        if (!tempOptions.branchIDValue || !tempOptions.branchIDValue.id) {
            newErrors.branchIDValue = 'Required';
        }

        if (!tempOptions.franchiseCodeValue || !tempOptions.franchiseCodeValue.id) {
            newErrors.franchiseCodeValue = 'Required';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            showToast('Please fill all mandatory fields', 'error');
            return;
        }

        const payload = {
            ...state,
            WIPNumber: state.WIPNumber ? parseInt(state.WIPNumber) : 0,
            PriorityNumber: state.PriorityNumber ? parseInt(state.PriorityNumber) : null,
            BranchId: tempOptions.branchIDValue && tempOptions.branchIDValue.id ? parseInt(tempOptions.branchIDValue.id) : null,
            FranchiseCode: tempOptions.franchiseCodeValue && tempOptions.franchiseCodeValue.id ? parseInt(tempOptions.franchiseCodeValue.id) : null,
            DateTimeDueIn: state.DateTimeDueIn || null,
            DateTimeDueOut: state.DateTimeDueOut || null,
            WorkflowAssignedDate: state.WorkflowAssignedDate || null,
            WLDateIn: state.WLDateIn || null,
            WLDateOut: state.WLDateOut || null
        };

        setIsBtnLoader(true);
        try {
            let res = await createHeaderRecord(payload);
            if (res && res.success) {
                showToast('Job created successfully!');
                props.handleCancel();
            } else {
                showToast('Error creating job', 'error');
            }
        } finally {
            setIsBtnLoader(false);
        }
    };

    const [tempOptions, setTempOptions] = useState({
        branchIDValue: null,
        franchiseCodeValue: null
    });

    const singleSelectChange = (nm) => (ev, val) => {
        setTempOptions((st) => {
            let newSt = { ...st, [nm]: val };
            return newSt;
        });
        if (errors[nm]) {
            setErrors((errs) => ({ ...errs, [nm]: null }));
        }
    };

    return (
        <div style={{ padding: 10 }}>
            <Grid container spacing={2} alignItems="flex-start">
                {/* ---------- ROW 1: CORE JOB INFO ---------- */}
                <Grid item xs={12} sm={6} md={3}>
                    <ClickAwayListener onClickAway={() => setShowRegPopper(false)}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <InputLabel shrink required error>
                                Registration
                            </InputLabel>
                            <TextBox name="Registration" value={state.Registration} onChange={handleRegChange} autoComplete="off" />
                            {errors.Registration && <FormHelperText error>{errors.Registration}</FormHelperText>}

                            <Popper open={showRegPopper} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: 1300, width: 600 }}>
                                <Paper style={{ maxHeight: 300, overflow: 'auto', border: '1px solid #ddd', marginTop: 5 }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            fontWeight: 'bold',
                                            padding: '10px 15px',
                                            borderBottom: '1px solid #ddd',
                                            backgroundColor: '#f5f5f5',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>Reg No</div>
                                        <div style={{ flex: 1.5 }}>Chassis No</div>
                                        <div style={{ flex: 1 }}>Model</div>
                                        <div style={{ flex: 1 }}>Account</div>
                                    </div>
                                    {regOptions.length > 0 ? (
                                        regOptions.map((option, idx) => (
                                            <div
                                                key={idx}
                                                onClick={() => handleSelectReg(option)}
                                                style={{ display: 'flex', padding: '10px 15px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                            >
                                                <div style={{ flex: 1 }}>{option.registrationNumber}</div>
                                                <div style={{ flex: 1.5, wordBreak: 'break-all', paddingRight: 5 }}>{option.chassisNumber}</div>
                                                <div style={{ flex: 1 }}>{option.modelCode}</div>
                                                <div style={{ flex: 1 }}>{option.accountCode}</div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ padding: '15px', textAlign: 'center' }}>
                                            <div style={{ marginBottom: 10 }}>No matching registration found.</div>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => {
                                                    setShowRegPopper(false);
                                                    setShowVehicleModal(true);
                                                }}
                                            >
                                                Add New Vehicle
                                            </Button>
                                        </div>
                                    )}
                                </Paper>
                            </Popper>
                        </div>
                    </ClickAwayListener>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink required error>
                        Customer Name
                    </InputLabel>
                    <TextBox name="CustomerName" value={state.CustomerName} onChange={fieldChange} />
                    {errors.CustomerName && <FormHelperText error>{errors.CustomerName}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        Account No
                    </InputLabel>
                    <TextBox name="AccountNo" value={state.AccountNo} onChange={fieldChange} />
                    {errors.AccountNo && <FormHelperText error>{errors.AccountNo}</FormHelperText>}
                </Grid>

                {/* ---------- ROW 2: VEHICLE & JOB METADATA ---------- */}
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        Make / Model
                    </InputLabel>
                    <TextBox name="MakeModel" value={state.MakeModel} onChange={fieldChange} />
                    {errors.MakeModel && <FormHelperText error>{errors.MakeModel}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        S24 Chassis Number
                    </InputLabel>
                    <TextBox name="S24ChassisNumber" value={state.S24ChassisNumber} onChange={fieldChange} />
                    {errors.S24ChassisNumber && <FormHelperText error>{errors.S24ChassisNumber}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        WIP Number
                    </InputLabel>
                    <TextBox name="WIPNumber" value={state.WIPNumber} onChange={fieldChange} />
                    {errors.WIPNumber && <FormHelperText error>{errors.WIPNumber}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink>Priority Number</InputLabel>
                    <TextBox name="PriorityNumber" value={state.PriorityNumber} onChange={fieldChange} />
                </Grid>

                {/* ---------- ROW 3: OPERATIONS & BRANCH ---------- */}
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error={!!errors.branchIDValue}>
                        Branch
                    </InputLabel>
                    <SingelSelect
                        options={dropdowns?.branchList || []}
                        value={tempOptions.branchIDValue}
                        onChange={singleSelectChange('branchIDValue')}
                        disabled={state.isReadOnly}
                    />
                    {errors.branchIDValue && <FormHelperText error>{errors.branchIDValue}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error={!!errors.franchiseCodeValue}>
                        Franchise
                    </InputLabel>
                    <SingelSelect
                        options={dropdowns?.franchiseRecords || []}
                        value={tempOptions.franchiseCodeValue}
                        onChange={singleSelectChange('franchiseCodeValue')}
                        disabled={state.isReadOnly}
                    />
                    {errors.franchiseCodeValue && <FormHelperText error>{errors.franchiseCodeValue}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        Creating Operator
                    </InputLabel>
                    <TextBox name="CreatingOperator" value={state.CreatingOperator} onChange={fieldChange} />
                    {errors.CreatingOperator && <FormHelperText error>{errors.CreatingOperator}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink required error>
                        Owning Operator
                    </InputLabel>
                    <TextBox name="OwningOperator" value={state.OwningOperator} onChange={fieldChange} />
                    {errors.OwningOperator && <FormHelperText error>{errors.OwningOperator}</FormHelperText>}
                </Grid>

                {/* ---------- ROW 4: DATES ---------- */}
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink style={{ marginBottom: 8 }}>
                        Due In
                    </InputLabel>
                    <DateTimePicker name="DateTimeDueIn" value={state.DateTimeDueIn} onChange={fieldChange} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink style={{ marginBottom: 8 }}>
                        Due Out
                    </InputLabel>
                    <DateTimePicker name="DateTimeDueOut" value={state.DateTimeDueOut} onChange={fieldChange} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink style={{ marginBottom: 8 }}>
                        WL Date In
                    </InputLabel>
                    <DateTimePicker name="WLDateIn" value={state.WLDateIn} onChange={fieldChange} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink style={{ marginBottom: 8 }}>
                        WL Date Out
                    </InputLabel>
                    <DateTimePicker name="WLDateOut" value={state.WLDateOut} onChange={fieldChange} />
                </Grid>

                {/* ---------- ROW 5: WORKFLOW DATE + TEXT BLOCKS ---------- */}
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink style={{ marginBottom: 8 }}>
                        Workflow Assigned Date
                    </InputLabel>
                    <DateTimePicker name="WorkflowAssignedDate" value={state.WorkflowAssignedDate} onChange={fieldChange} />
                </Grid>
                <Grid item xs={12} sm={6} md={9}></Grid>

                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink required error>
                        Service Text 001
                    </InputLabel>
                    <TextBox name="ServiceText001" value={state.ServiceText001} onChange={fieldChange} minRows={3} multiline />
                    {errors.ServiceText001 && <FormHelperText error>{errors.ServiceText001}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <InputLabel shrink required error>
                        Customer Rating Notes
                    </InputLabel>
                    <TextBox name="CustomerRatingNotes" value={state.CustomerRatingNotes} onChange={fieldChange} minRows={3} multiline />
                    {errors.CustomerRatingNotes && <FormHelperText error>{errors.CustomerRatingNotes}</FormHelperText>}
                </Grid>

                {/* ---------- ROW 6: FLAGS & STATUS ---------- */}
                <Grid item xs={12} style={{ marginTop: 20 }}>
                    <InputLabel shrink>Flags & Status</InputLabel>
                    <Grid container spacing={1}>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.HighPriority} onChange={fieldChange} name="HighPriority" color="primary" />}
                                label="High Priority"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.CustomerWaiting} onChange={fieldChange} name="CustomerWaiting" color="primary" />}
                                label="Customer Waiting"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.CourtesyCarReq} onChange={fieldChange} name="CourtesyCarReq" color="primary" />}
                                label="Courtesy Car Req"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.IsFMOrWarranty} onChange={fieldChange} name="IsFMOrWarranty" color="primary" />}
                                label="FM / Warranty"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.IsBreakdown} onChange={fieldChange} name="IsBreakdown" color="primary" />}
                                label="Breakdown"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.IsNightShift} onChange={fieldChange} name="IsNightShift" color="primary" />}
                                label="Night Shift"
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                control={<Checkbox checked={state.DeleteFlag} onChange={fieldChange} name="DeleteFlag" color="primary" />}
                                label="Delete Flag"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20, marginBottom: 20 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4} style={{ marginLeft: 'auto' }}>
                            <SecondaryButton onClick={handleSave} isBtnLoader={isBtnLoader} fullWidth>
                                CREATE JOB
                            </SecondaryButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {showVehicleModal && <VehicleModal open={showVehicleModal} onClose={handleCloseVehicleModal} defaultReg={searchedReg} />}
        </div>
    );
};

export default CreateJobs;
